import AppData from "../const/app_data";

const { ccclass, property } = cc._decorator;

@ccclass
export default class MenuScrollWidget extends cc.Component {

    @property(cc.Node)
    moduleNode: cc.Node = null

    @property(cc.Widget)
    leftWidget: cc.Widget = null

    @property(cc.Widget)
    scrollWidget: cc.Widget = null

    _leftWidget_left = 0
    _scrollWidget_left = 0
    _scrollWidget_right = 0

    onLoad() {
        this._leftWidget_left = this.leftWidget.left
        this._scrollWidget_left = this.scrollWidget.left
        this._scrollWidget_right = this.scrollWidget.right
    }

    refreshUI() {
        if (!AppData.isWidescreen) {
            return
        }
        let widget = this.moduleNode.getComponent(cc.Widget)
        if (widget) {
            widget.updateAlignment()
        }
        this.leftWidget.left = this._leftWidget_left + AppData.widescreenOffset
        this.scrollWidget.left = this._scrollWidget_left + AppData.widescreenOffset
        this.scrollWidget.right = this._scrollWidget_right + AppData.widescreenOffset

        this.leftWidget.updateAlignment()
        this.scrollWidget.updateAlignment()
    }

}
